import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

interface RecommendSectionProps {
  currentId: number;
}

export default function RecommendSection({ currentId }: RecommendSectionProps) {
  const recommended = featuredComics.filter((c) => c.id !== currentId).slice(0, 4);

  return (
    <section className="flex flex-col lg:flex-row min-h-[450px]">
      <div className="lg:w-1/2 relative overflow-hidden bg-accent-100/60">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20collection%20display%2C%20multiple%20comic%20covers%20arranged%20artistically%2C%20warm%20cozy%20reading%20nook%2C%20soft%20lighting%2C%20webtoon%20aesthetic%2C%20digital%20illustration%20style%2C%20inviting%20atmosphere&width=800&height=700&seq=recommend-01&orientation=landscape"
          alt="推荐阅读"
          title="猜你喜欢 - 韩漫漫画网推荐"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute top-6 left-6">
          <span className="text-xs text-foreground-600 font-medium bg-background-50/80 px-3 py-1 rounded-full whitespace-nowrap">
            为你推荐
          </span>
        </div>
        <div className="absolute bottom-8 left-6">
          <h3 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight whitespace-nowrap">
            猜你<br />喜欢
          </h3>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex flex-col justify-center px-8 md:px-12 py-14">
        <h3 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 mb-3 whitespace-nowrap">
          猜你喜欢
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-md">
          根据你的阅读偏好，为你精心挑选以下推荐作品，发现更多精彩的韩国漫画。
        </p>
        <div className="grid grid-cols-2 gap-3">
          {recommended.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex items-center gap-3 p-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors duration-200 cursor-pointer group"
            >
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-12 h-16 rounded object-cover flex-shrink-0"
                loading="lazy"
              />
              <div className="min-w-0">
                <p className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 truncate whitespace-nowrap">
                  {comic.title}
                </p>
                <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{comic.category}</p>
                <p className="text-xs text-primary-500 font-bold mt-0.5 whitespace-nowrap">⭐ {comic.rating}</p>
              </div>
            </Link>
          ))}
        </div>
        <Link
          to="/category"
          className="mt-8 self-start px-6 py-2.5 rounded-full bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
        >
          浏览更多
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}